<template>
  <div class="homepage-component hp-quick-links" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="quick-links-component padding-lg">
      <div class="container">
        <div class="row text-center title-row">
          <div class="col-xs-12">
            <h2 class="quick-link__header-title">Discover</h2>
          </div>
        </div>
        <div class="row links-row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-md-offset-custom-2 col-lg-3 animation-element appear-grow-slow in-view">
            <a href="#" class="quick-link">
              <svg class="light-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#ffffff"></path>
              </svg>
              <svg class="dark-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#1a1a1a"></path>
              </svg>
              <h3 class="quick-link__title">Search Inventory</h3>
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 animation-element appear-grow-slow reveal2 in-view">
            <a href="#" class="quick-link">
              <svg class="light-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#ffffff"></path>
              </svg>
              <svg class="dark-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#1a1a1a"></path>
              </svg>
              <h3 class="quick-link__title">Get Pre-Approved</h3>
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-md-offset-custom-2 col-lg-3 animation-element appear-grow-slow reveal3 in-view">
            <a href="#" class="quick-link">
              <svg class="light-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#ffffff"></path>
              </svg>
              <svg class="dark-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#1a1a1a"></path>
              </svg>
              <h3 class="quick-link__title">Schedule Service</h3>
            </a>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 animation-element appear-grow-slow reveal4 in-view">
            <a href="#" class="quick-link">
              <svg class="light-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#ffffff"></path>
              </svg>
              <svg class="dark-arrow" xmlns="http://www.w3.org/2000/svg" width="34.287" height="34.287" viewBox="0 0 34.287 34.287">
                <path id="CarbonArrowUpRight_2_" data-name="CarbonArrowUpRight (2)" d="M12.857,6V9.429H34.441L6,37.87l2.417,2.417L36.858,11.846V33.429h3.429V6Z" transform="translate(-6 -6)" fill="#1a1a1a"></path>
              </svg>
              <h3 class="quick-link__title">Value Your Trade</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand,
      }
    },
    computed: {
    },
    mounted() {
      $(function() {
        var scrollSwoop = {
          init: function() {
            var $animation_elements = $('.animation-element');
            var $window = $(window);
          
            function check_if_in_view() {
              var window_height = $window.height() * .85;
              var window_top_position = $window.scrollTop();
              var window_bottom_position = (window_top_position + window_height);
              $.each($animation_elements, function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);
          
                if ((element_bottom_position >= window_top_position) &&
                    (element_top_position <= window_bottom_position)) {
                  if ($element.hasClass("reveal2") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 300);
                  }
                  else if ($element.hasClass("reveal3") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 600);
                  } 
                  else if ($element.hasClass("reveal4") === true) {
                    setTimeout(function() {
                      $element.addClass('in-view');
                    }, 900);
                  }
                  else {
                    $element.addClass('in-view');
                  }
                }
              });
            }
            $window.on('scroll resize', check_if_in_view);
            $window.trigger('scroll');
          }
        }
        $(document).ready(scrollSwoop.init);
      });
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .quick-links-component.padding-lg {
    padding-top: 5%;
    padding-bottom: 5%;
  }
  .quick-links-component .quick-link,
  .quick-links-component .quick-link:hover,
  .quick-links-component .quick-link:active,
  .quick-links-component .quick-link:focus {
    text-decoration: none;
    outline: none;
  }
  .quick-links-component .quick-link:hover {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  .quick-link__header-title {
    font-size: 2.5rem;
    margin-bottom: 25px;
    letter-spacing: 2px;
    font-weight: 400;
    /* text-transform: uppercase; */
  }
  .quick-links-component .quick-link {
    border-radius: 0;
    padding: 25px;
    height: 250px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin: 15px auto;
    max-width: 250px;
    /* text-transform: uppercase; */
    background-color: #fff;
    border: 1px solid var(--primary-dark);
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .hp-quick-links[data-brand="infiniti"] .quick-links-component .quick-link {
    border-color: var(--secondary-color);
  }

  .quick-links-component .quick-link:hover {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }
  .hp-quick-links[data-brand="infiniti"] .quick-links-component .quick-link {
    border-color: var(--primary-color);
  }
  .hp-quick-links[data-brand="cjdr"] .quick-links-component .quick-link:hover {
    background-color: var(--secondary-color);
    border-color: var(--secondary-color);
  }
  .quick-links-component .quick-link .quick-link__title {
    font-family: var(--heading-text) !important;
    color: var(--primary-dark);
    font-size: 1.5rem;
    text-align: left;
    max-width: 90%;
    margin-right: auto;
    letter-spacing: 1.2px;
    font-weight: 400;
  }

  .quick-links-component .light-arrow,
  .quick-links-component .dark-arrow {
    margin-left: auto;
  }
  .quick-links-component .dark-arrow path {
    fill: var(--primary-dark) !important;
  }
  .quick-links-component .light-arrow,
  .quick-links-component .quick-link:hover .dark-arrow {
    display: none;
  }
  .quick-links-component .quick-link:hover .light-arrow {
    display: block;
  }
  .quick-links-component .quick-link:hover .quick-link__title {
    color: #fff;
  }
  .animation-element.appear-grow-slow {
    opacity: 0;
    -moz-transition: all 1500ms ease-out;
    -webkit-transition: all 1500ms ease-out;
    -o-transition: all 1500ms ease-out;
    transition: all 1500ms ease-out;
    transition-property: opacity, transform;
    -moz-transform: scale(.97);
    -webkit-transform: scale(.97);
    -o-transform: scale(.97);
    -ms-transform: scale(.97);
    transform: scale(.97);
  }
  .animation-element.appear-grow-slow.in-view {
    opacity: 1;
    -moz-transform: scale(1);
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    .quick-links-component .col-md-offset-custom-2 {
      margin-left: 16.6666666667%;
    }
  }
</style>
